import React, { Suspense } from "react";
import PropTypes from "prop-types";
import { EmptyComponent } from "./EmptyComponent.js";

/**
 * Wrapper component for React.Suspense with consistent fallback behavior
 * Replaces react-loadable's loading prop functionality
 */
export const SuspenseWrapper = ({
  children,
  fallback = <EmptyComponent />
}) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};

SuspenseWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node
};

/**
 * Higher-order component to wrap lazy-loaded components with Suspense
 * Usage: export const MyComponent = withSuspense(lazy(() => import('./MyComponent')));
 */
export const withSuspense = (LazyComponent, fallback = <EmptyComponent />) => {
  const WrappedComponent = props => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = `withSuspense(${LazyComponent.displayName || LazyComponent.name || "Component"})`;

  return WrappedComponent;
};
